<template>
    <v-card
        class="dashboard-card ma-2"
        elevation="4"
    >
        <v-card-title>Management Accounts</v-card-title>
        <v-card-subtitle>number of accounts, by days</v-card-subtitle>

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-NEW--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">New</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.New,
                                claimHasPodFile: false,
                                agedDaysMax: 1,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-1</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.new.group0_1}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.new.group0_1_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.New,
                                claimHasPodFile: false,
                                agedDaysMin: 2,
                                agedDaysMax: 3,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">2-3</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.new.group2_3}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.new.group2_3_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.New,
                                claimHasPodFile: false,
                                agedDaysMin: 4,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">4+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.new.group4_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.new.group4_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-VERIFIED--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Verified</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Verified,
                                claimHasPodFile: false,
                                agedDaysMaxByVerifiedAt: 10,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-10</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.verified.group0_10 }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.verified.group0_10_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Verified,
                                claimHasPodFile: false,
                                agedDaysMinByVerifiedAt: 11,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">11+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.verified.group11_Plus }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.verified.group11_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-QUERIED--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Queried</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Queried,
                                claimHasPodFile: false,
                                agedDaysMaxByQueriedAt: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.queried.group0_7}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.queried.group0_7_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Queried,
                                claimHasPodFile: false,
                                agedDaysMinByQueriedAt: 8,
                                agedDaysMaxByQueriedAt: 15,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">8-15</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.queried.group8_15}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.queried.group8_15_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Queried,
                                claimHasPodFile: false,
                                agedDaysMinByQueriedAt: 16,
                                agedDaysMaxByQueriedAt: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">16-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.queried.group16_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.queried.group16_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Queried,
                                claimHasPodFile: false,
                                agedDaysMinByQueriedAt: 31,
                                agedDaysMaxByQueriedAt: 60,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.queried.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.queried.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Queried,
                                claimHasPodFile: false,
                                agedDaysMinByQueriedAt: 61,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">61+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.queried.group61_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.queried.group61_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-PROCESSED-NOT-FINAL--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Processed Not Final</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Processed,
                                hasFinalAccount: false,
                                claimHasPodFile: false,
                                agedDaysMaxByProcessedAt: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.processedNotFinal.group0_7}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.processedNotFinal.group0_7_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Processed,
                                hasFinalAccount: false,
                                claimHasPodFile: false,
                                agedDaysMinByProcessedAt: 8,
                                agedDaysMaxByProcessedAt: 15,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">8-15</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.processedNotFinal.group8_15}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.processedNotFinal.group8_15_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Processed,
                                hasFinalAccount: false,
                                claimHasPodFile: false,
                                agedDaysMinByProcessedAt: 16,
                                agedDaysMaxByProcessedAt: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">16-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.processedNotFinal.group16_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.processedNotFinal.group16_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Processed,
                                hasFinalAccount: false,
                                claimHasPodFile: false,
                                agedDaysMinByProcessedAt: 31,
                                agedDaysMaxByProcessedAt: 60,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.processedNotFinal.group31_60}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.processedNotFinal.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Processed,
                                hasFinalAccount: false,
                                claimHasPodFile: false,
                                agedDaysMinByProcessedAt: 61,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">61+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.processedNotFinal.group61_Plus}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.processedNotFinal.group61_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-PROCESSED-HAS-FINAL--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Processed Has Final</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Processed,
                                hasFinalAccount: true,
                                claimHasPodFile: false,
                                agedDaysMaxByProcessedAt: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.processedHasFinal.group0_7 }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.processedHasFinal.group0_7_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Processed,
                                hasFinalAccount: true,
                                claimHasPodFile: false,
                                agedDaysMinByProcessedAt: 8,
                                agedDaysMaxByProcessedAt: 15,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">8-15</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.processedHasFinal.group8_15 }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.processedHasFinal.group8_15_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Processed,
                                hasFinalAccount: true,
                                claimHasPodFile: false,
                                agedDaysMinByProcessedAt: 16,
                                agedDaysMaxByProcessedAt: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">16-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.processedHasFinal.group16_30 }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.processedHasFinal.group16_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Processed,
                                hasFinalAccount: true,
                                claimHasPodFile: false,
                                agedDaysMinByProcessedAt: 31,
                                agedDaysMaxByProcessedAt: 60,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">31-60</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.processedHasFinal.group31_60 }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.processedHasFinal.group31_60_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Processed,
                                hasFinalAccount: true,
                                claimHasPodFile: false,
                                agedDaysMinByProcessedAt: 61,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">61+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.processedHasFinal.group61_Plus }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.processedHasFinal.group61_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-REJECTED--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Rejected</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Rejected,
                                claimHasPodFile: false,
                                agedDaysMaxByRejectedAt: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">0-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.rejected.group0_30 }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.rejected.group0_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>            
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Rejected,
                                claimHasPodFile: false,
                                agedDaysMinByRejectedAt: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.rejected.group31_Plus }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.rejected.group31_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <!--
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Rejected,
                                claimHasPodFile: false,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.rejected }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.rejected_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            -->
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-ACCEPTED--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <!-- <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Accepted</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                claimHasPodFile: false,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-green darken-2 white--text text-center"
                    dark
                >
                    <span class="header">Total</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{ dataObject.accepted }}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.accepted_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>-->
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-ACCEPTED-NOT-IN-DAYBATCH--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Accepted not in Day Batch</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                notReadyToBePrinted: false,
                                inDayBatch: false,
                                agedDaysMaxByAcceptedAt: 1,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-1</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.acceptedNotInDaybatch.group0_1}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.acceptedNotInDaybatch.group0_1_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                notReadyToBePrinted: false,
                                inDayBatch: false,
                                agedDaysMinByAcceptedAt: 2,
                                agedDaysMaxByAcceptedAt: 2,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">2</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.acceptedNotInDaybatch.group2}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.acceptedNotInDaybatch.group2_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                notReadyToBePrinted: false,
                                inDayBatch: false,
                                agedDaysMinByAcceptedAt: 3,
                                agedDaysMaxByAcceptedAt: 3,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">3</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.acceptedNotInDaybatch.group3}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.acceptedNotInDaybatch.group3_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                notReadyToBePrinted: false,
                                inDayBatch: false,
                                agedDaysMinByAcceptedAt: 4,
                                agedDaysMaxByAcceptedAt: 4,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">4</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.acceptedNotInDaybatch.group4}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.acceptedNotInDaybatch.group4_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>

                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                notReadyToBePrinted: false,
                                inDayBatch: false,
                                agedDaysMinByAcceptedAt: 5,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">5+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{dataObject.acceptedNotInDaybatch.group5_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            dataObject.acceptedNotInDaybatch.group5_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-ACCEPTED-NOT-READY-TO-BE-PRINTED-=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Accepted not ready to be printed</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                notReadyToBePrinted: true,
                                inDayBatch: false,
                                agedDaysMaxByAcceptedAt: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.acceptedNotReadyToBePrinted.group0_7}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.acceptedNotReadyToBePrinted.group0_7_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                notReadyToBePrinted: true,
                                inDayBatch: false,
                                agedDaysMinByAcceptedAt: 8,
                                agedDaysMaxByAcceptedAt: 14,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">8-14</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.acceptedNotReadyToBePrinted.group8_14}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.acceptedNotReadyToBePrinted.group8_14_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                notReadyToBePrinted: true,
                                inDayBatch: false,
                                agedDaysMinByAcceptedAt: 15,
                                agedDaysMaxByAcceptedAt: 21,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">15-21</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.acceptedNotReadyToBePrinted.group15_21}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.acceptedNotReadyToBePrinted.group15_21_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                notReadyToBePrinted: true,
                                inDayBatch: false,
                                agedDaysMinByAcceptedAt: 22,
                                agedDaysMaxByAcceptedAt: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">22-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.acceptedNotReadyToBePrinted.group22_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.acceptedNotReadyToBePrinted.group22_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                notReadyToBePrinted: true,
                                inDayBatch: false,
                                agedDaysMinByAcceptedAt: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{dataObject.acceptedNotReadyToBePrinted.group31_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            dataObject.acceptedNotReadyToBePrinted.group31_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->
        
        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-DAYBATCH-NOT-SUBMITTED--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Day Batch Not Submitted</h5>
            <v-row
                align="center"
                justify="start"
            >
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                claimHasPodFile: false,
                                inDayBatch: true,
                                agedDaysMaxByAcceptedAt: 7,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="light-blue lighten-2 black--text text-center"
                    dark
                >
                    <span class="header">0-7</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.dayBatchNotSubmitted.group0_7}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.dayBatchNotSubmitted.group0_7_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                claimHasPodFile: false,
                                inDayBatch: true,
                                agedDaysMinByAcceptedAt: 8,
                                agedDaysMaxByAcceptedAt: 14,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="lime black--text text-center"
                    dark
                >
                    <span class="header">8-14</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.dayBatchNotSubmitted.group8_14}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.dayBatchNotSubmitted.group8_14_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                claimHasPodFile: false,
                                inDayBatch: true,
                                agedDaysMinByAcceptedAt: 15,
                                agedDaysMaxByAcceptedAt: 21,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="amber black--text text-center"
                    dark
                >
                    <span class="header">15-21</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.dayBatchNotSubmitted.group15_21}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.dayBatchNotSubmitted.group15_21_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                claimHasPodFile: false,
                                inDayBatch: true,
                                agedDaysMinByAcceptedAt: 22,
                                agedDaysMaxByAcceptedAt: 30,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="orange darken-2 black--text text-center"
                    dark
                >
                    <span class="header">22-30</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">{{dataObject.dayBatchNotSubmitted.group22_30}}</h3>
                        <span class="facevalue">
                            R {{
                            dataObject.dayBatchNotSubmitted.group22_30_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
                <v-card
                    @click="
                        $router.push({
                            name: 'Accounts',
                            params: {
                                providerId: providerId,
                                areaId: areaId,
                                accountStatus: accountStatus.Accepted,
                                claimHasPodFile: false,
                                inDayBatch: true,
                                agedDaysMinByAcceptedAt: 31,
                            },
                        })
                    "
                    class="my-2 mx-3 ageing-stat"
                    color="deep-orange darken-2 white--text text-center"
                    dark
                >
                    <span class="header">31+</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="dataObject == null"
                    ></v-progress-circular>
                    <span v-else>
                        <h3 class="stat">
                            {{dataObject.dayBatchNotSubmitted.group31_Plus}}
                        </h3>
                        <span class="facevalue">
                            R {{
                            dataObject.dayBatchNotSubmitted.group31_Plus_Value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            }}
                        </span>
                    </span>
                </v-card>
            </v-row>
        </v-card-text>
        <!--#endregion-->

        <!--#region-=-=-=-=-=---=-=-=-=-=-=-=-=-=-FOOTER--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
        <v-divider></v-divider>
        <v-card-text>
            <v-row justify="end">
                <v-col
                    align-self="center"
                    cols="12"
                    md="6"
                >
                    <h5
                        class="text--secondary"
                        style="text-align: right"
                    >
                        Auto updates every
                        {{ (refreshSeconds / 60000).toString().substr(0, 4) }} minutes
                        or
                        <v-btn
                            @click="getData"
                            class="ml-1 white--text"
                            color="secondary darken-1"
                            elevation="4"
                            fab
                            x-small
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </h5>
                </v-col>
            </v-row>
        </v-card-text>
        <!--#endregion-->
    </v-card>
</template>

<script>
import AccountStatus from "../../../constants/AccountStatus.constant";
export default {
    name: "ManagementAccountsWidget",
    props: {
        selectedAreaProviderFilter: {
            type: Object,
            default: () => {
                return { areaId: 0, providerId: 0 };
            }
        }
    },
    data: () => ({
        dataObject: null,
        refreshTimeout: null,
        refreshSeconds: 300000,
        storeDispatch: "accounts/getmanagementaccountswidgetdto",
        accountStatus: AccountStatus,
        providerId: 0,
        areaId: 0,
        //
    }),
    mounted: function() {
        this.refreshTimeout = setTimeout(this.getData, 0);
    },
    computed: {
        //
    },
    watch: {
        selectedAreaProviderFilter: function() {
            this.providerId = this.selectedAreaProviderFilter.providerId;
            this.areaId = this.selectedAreaProviderFilter.areaId;
            this.getData();
        }
    },
    methods: {
        getData() {
            this.stopRefreshTimeOut();
            this.dataObject = null;

            this.$store
                .dispatch(this.storeDispatch, {
                    urlParameters: {
                        providerId: this.selectedAreaProviderFilter.providerId,
                        areaId: this.selectedAreaProviderFilter.areaId
                    }
                })
                .then(dataResponse => {
                    this.dataObject = dataResponse;
                })
                .finally(() => {
                    this.refreshTimeout = setTimeout(
                        this.getData,
                        this.refreshSeconds
                    );
                });
        },
        stopRefreshTimeOut() {
            if (this.refreshTimeout != null) clearTimeout(this.refreshTimeout);
        }
        //--------------------
    },
    destroyed: function() {
        this.stopRefreshTimeOut();
    }
};
</script>

<style lang="stylus" scoped>
span {
    .facevalue {
        font-size: 0.54rem;
    }
}

#app.theme--light {
    span.facevalue {
        color: black !important;
    }
}

#app.theme--dark {
    span.facevalue {
        color: white !important;
    }
}
</style>